import { filter, orderBy } from 'lodash';
import {
  Market, Sector, Settings,
} from '@compassdigital/foodworks.ts.sdk';

export default class ConfigUtil {
  /**
   * Parses the sector array and returns alphabetical sorted sector
   * @param sector
   */
  public static filterSector(sector: Array<Sector>) {
    const mappedArray = !sector || sector.map((value: Sector) => value);
    return orderBy(mappedArray, [(user:any) => user.name.toLowerCase()], 'asc');
  }

  /**
   * Parses the market array and returns alphabetical sorted market
   * @param market
   */
  public static filterMarket(market: Array<Market>) {
    const mappedMarket = !market || market.map((value: Market) => value);
    return orderBy(mappedMarket, [(user:any) => user.name.toLowerCase()], 'asc');
  }

  /**
   * Parses the cuisines array and returns alphabetical sorted cuisines
   * @param cuisines
   */
  public static filterCuisines(cuisines: Array<Settings>) {
    // const mappedMarket = !cuisines || cuisines.map((value: Market) => value);
    // return orderBy(mappedMarket, 'name', 'asc');
  }
}
